<template>
  <v-container fluid>
    <v-progress-linear
      v-if="$vars.loading"
      indeterminate
      class="primary--text loader"
    ></v-progress-linear>
    <v-toolbar dense flat>
      <v-toolbar-items>
      <v-tabs v-model="tab">
        <v-tab>{{ props }}</v-tab>
        <v-tab>Andere Chargen</v-tab>
        <v-tab>Neu</v-tab>
      </v-tabs>
      </v-toolbar-items>
    </v-toolbar>
    <v-divider></v-divider>
    <v-row class="mt-2">
      <v-col cols="12" class="pt-0 pa-0">
        <v-tabs-items v-model="tab">
          <v-tab-item><v-col cols="12" class="ma-0 pa-0"><todoSeite ToDo="false" :showTitle="props.text" :wer="props" anzahl="-1"></todoSeite></v-col></v-tab-item>
          <v-tab-item><v-col cols="12" class="ma-0 pa-0"><todoSeite ToDo="false" showTitle="Andere Chargen" wer="alle" anzahl="-1"></todoSeite></v-col></v-tab-item>
          <v-tab-item><v-col cols="12"><todoSeite ToDo="true"></todoSeite></v-col></v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: ['props'],
  data () {
    return {
      tab: null
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// todo.vue?16c497fa